/**
 * Design Specs:
 * https://www.figma.com/file/2UlxeTUdKRMOHjl0h3rOg1/Starter-File-Multi-Step-Forms-AKA-Wizards?node-id=119%3A24517
 */

import styled, { css } from 'styled-components';
import { Alert, List, mediaMixin, spaceMixin, spacingMixin, token } from '@zillow/constellation';

export const StyledAlert = styled(Alert)`
  margin-bottom: ${spaceMixin('md')};
`;

export const StyledFlexContainer = styled.div<{ breakpoint?: string }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  /* 1281 or passed in breakpoint*/
  ${(props) => css`
    ${mediaMixin(
      `${props.breakpoint || 'xxl'}`,
      css`
        flex-direction: row;
      `,
    )}
  `}
`;

export const StyledExampleText = styled.div`
  color: ${token('colors.coolGray500')};
  font-size: 0;

  /* Inside Auto Layout */
  flex: none;
  order: 2;
  flex-grow: 0;
  margin: 8px 0px;

  ${mediaMixin(
    'md',
    css`
      font-size: ${spaceMixin(2)};
    `,
  )}
`;

// TODO: add megaphone svg icon
export const StyledDetailedIcon = styled.div`
  ${spacingMixin}
`;

export const StyledTitleSection = styled.div`
  > * {
    margin-bottom: ${spaceMixin('sm')};
  }

  margin-bottom: ${spaceMixin('lg')};
`;

export const StyledList = styled(List)`
  font-size: 12px;
`;

export const StyledDependentFormSectionContainer = styled.div<{ isDisabled: boolean }>`
  flex-grow: 1;

  margin-top: ${spaceMixin(8)};

  opacity: ${({ isDisabled }) => (isDisabled ? '0.4' : '1')};
`;

export const StyledDivCustomLeftSpacing = styled.div`
  /*this is a hacky fix for the tip card on this page being aligned slightly left of the ones on other form pages.*/
  @media (min-width: ${token('breakpoints.xxl')}px) {
    margin-left: 19.5px;
  }
`;
